import { useResetQueryErrors } from '../../hooks/query';
import {
  useQueryStateContext,
  useVisualComponentsContext,
  useQueryHistoryStateContext,
} from '../../contexts';

export const RedoButton = () => {
  const { RedoQueryButton: VisualComponent } = useVisualComponentsContext();
  const { redoQuery, redoStack } = useQueryHistoryStateContext();
  const { isReadOnly = false } = useQueryStateContext();
  const resetQueryErrors = useResetQueryErrors();
  const handleRedo = () => {
    redoQuery();
    resetQueryErrors();
  };
  const isRedoStackEmpty = redoStack.length === 0;

  return <VisualComponent isDisabled={isReadOnly || isRedoStackEmpty} onClick={handleRedo} />;
};
